import EditEventPageComponent from "./components/EditEventPageComponent";

import { useSelector } from "react-redux";
import axios from 'axios'
import { useDispatch } from "react-redux";
import { saveAttributeToCatDoc } from "../../redux/actions/categoryActions";
import { uploadImagesApiRequest, uploadImagesCloudinaryApiRequest } from "./utils/utils";

const fetchEvent = async (eventId) => {
    const { data } = await axios.get(`/api/events/get-one/${eventId}`);
    return data;
}

const updateEventApiRequest = async (eventId, formInputs) => {
    const { data } = await axios.put(`/api/events/admin/${eventId}`, { ...formInputs });
    return data;
}

const AdminEditEventPage = () => {

  const { categories } = useSelector((state) => state.getCategories);

  const reduxDispatch = useDispatch();

  const imageDeleteHandler = async (imagePath, eventId) => {
      let encoded = encodeURIComponent(imagePath)
      if (process.env.NODE_ENV !== "production") {
          // to do: change to !==
        await axios.delete(`/api/events/admin/image/${encoded}/${eventId}`);
      } else {
        await axios.delete(`/api/events/admin/image/${encoded}/${eventId}`);
      }
  }

  return <EditEventPageComponent 
            categories={categories} 
            fetchEvent={fetchEvent} 
            updateEventApiRequest={updateEventApiRequest} 
            reduxDispatch={reduxDispatch} 
            saveAttributeToCatDoc={saveAttributeToCatDoc} 
            imageDeleteHandler={imageDeleteHandler} 
            uploadImagesApiRequest={uploadImagesApiRequest} 
            uploadImagesCloudinaryApiRequest={uploadImagesCloudinaryApiRequest}  />;
};

export default AdminEditEventPage;
